import { useState } from "react";
import { LifeBuoy, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { PageHeader, Card } from "@/components/ui-kit";

const inp = "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm outline-none focus:border-[#5aa469]";

export default function Support() {
  const { t } = useT();
  const [f, setF] = useState({ subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/support", f); setSent(true); toast.success(t("support_sent")); } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="support-page" className="mx-auto max-w-2xl">
      <PageHeader title={t("nav_support")} />
      <p className="-mt-4 mb-6 text-sm text-slate-500">{t("support_sub")}</p>
      <Card>
        <div className="mb-5 flex items-center gap-3 text-sm text-slate-600"><LifeBuoy size={18} className="text-[#4a8a56]" />{t("support_email_hint")} <a href="mailto:emergeresoftware@gmail.com" className="font-semibold text-[#4a8a56]">emergeresoftware@gmail.com</a></div>
        {sent ? <p data-testid="support-success" className="rounded-xl bg-emerald-50 p-4 text-sm text-emerald-800">{t("support_sent_desc")}</p> : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="support-subject" required minLength={3} placeholder={t("support_subject_ph")} className={inp} value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} />
            <textarea data-testid="support-message" required minLength={10} rows={6} placeholder={t("support_message_ph")} className={inp} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} />
            <button data-testid="support-submit" disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-[#5aa469] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#4a8a56] disabled:opacity-60">{busy ? "…" : t("contact_send")} <Send size={14} /></button>
          </form>
        )}
      </Card>
    </div>
  );
}
